/**
 * Blog posts that also exist in German (/de/blog/:slug).
 *
 * The blog is English-only by design: every other /{lang}/blog/:slug canonicalizes to
 * /en/. A slug listed here is genuinely translated, so its /de/ URL is self-canonical
 * and forms an en+de hreflang pair with the English post. Read by BlogPostPage (content +
 * meta), src/App.jsx (canonical + hreflang), scripts/prerender.js (prerender + sitemap)
 * and scripts/prerender-playwright.js (page list).
 *
 * A slug may only be added once its German body is registered in BlogPostPage's
 * BLOG_CONTENT_MAP_DE, or the German URL would render English text.
 *
 * Plain data, no imports: App.jsx loads it eagerly.
 */
export const GERMAN_BLOG = {
  'telc-b2-schreiben-guide': {
    title: 'telc B2 Schreiben: Aufbau, Musterbrief & Bewertung (2026)',
    excerpt:
      'Der Schriftliche Ausdruck in telc B2 ist ein Strukturtest: 30 Minuten, ein formeller Brief, drei von vier Leitpunkten. Mit den Bewertungskriterien, einer Fünf-Absätze-Vorlage und einem vollständigen Musterbrief.',
    // Written for the SERP. Mirrors the English post's target queries ("telc b2 schreiben", "struktur schreiben b2 telc").
    metaDescription:
      'telc B2 Schreiben: Aufbau und Struktur, 30 Minuten, drei von vier Leitpunkten, die Bewertungskriterien und ein vollständiger Musterbrief (Beschwerdebrief).',
    dateFormatted: '28. Juli 2026',
    readTime: '8 Min. Lesezeit',
  },
};

export const hasGermanBlog = (slug) => Object.prototype.hasOwnProperty.call(GERMAN_BLOG, slug);
